import React from "react";
import bgImage from "../Assessts/cybersecuritys.png";

const CyberSecurity = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "white",
        fontFamily: "sans-serif",
        color: "#2d3748",
      }}
    >
      {/* Hero Section */}
              <div style={{ position: "relative",marginBottom:50,  }}>
                <img
                  src={bgImage}
                  alt="About Us"
                  style={{
                    width: "100vw",
                    height: "80vh",
                    objectFit: "fit",
                    filter: "brightness(90%)",
                    display:"block"
                    
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  <h1 style={{ fontSize: "48px", fontWeight: "bold" }}>CyberSecurity</h1>
                  <p>
                    <span style={{ color: "#fff" }}>Home</span>{" "}
                    {/* <span style={{ color: "rgba(89, 2, 96, 1)" }}>/certificates</span> */}
                    <span style={{ color: "skyblue"}}>/CyberSecurity</span>
                  </p>
                </div>
              </div>

      {/* About Cybersecurity */}
      <div style={{ padding: "14px 16px" }}>
        <div
          style={{
            maxWidth: "1024px",
            margin: "0 auto",
            textAlign: "center",
          }}
        >
          <h2
            style={{
              fontSize: "1.875rem",
              fontWeight: "bold",
              color: "#105184ff",
              marginBottom: "24px",
            }}
          >
            Why Cybersecurity Matters
          </h2>
          <p
            style={{
              fontSize: "1.125rem",
              color: "#374151",
              lineHeight: 1.75,
              marginBottom: "12px",
            }}
          >
            In today’s interconnected world, cyber threats are as critical as
            physical threats. Aerospace, defence, and scientific sectors rely on
            secure networks and resilient systems to safeguard sensitive data,
            national security, and mission-critical operations. Technocrat
            provides advanced cybersecurity solutions to ensure confidentiality,
            integrity, and availability across all platforms.
          </p>
        </div>
      </div>

      {/* Services Offering Section */}
      <div style={{ padding: "4px 16px", backgroundColor: "#f9fafb" }}>
        <div
          style={{
            maxWidth: "1100px",
            margin: "0 auto",
            textAlign: "center",
          }}
        >
          <h2
            style={{
              fontSize: "1.875rem",
              fontWeight: "bold",
              color: "#105184ff",
              marginBottom: "24px",
            }}
          >
            Cybersecurity Solutions We Provide
          </h2>
          <ul
            style={{
              textAlign: "left",
              fontSize: "1.125rem",
              lineHeight: 1.8,
              color: "#374151",
              maxWidth: "800px",
              margin: "0 auto",
            }}
          >
            <li>
              🔐 <b>Network Security:</b> Firewalls, intrusion prevention, and
              advanced monitoring to defend against unauthorized access.
            </li>
            <li>
              🛡️ <b>Endpoint Protection:</b> Securing devices with
              anti-malware, encryption, and zero-trust architecture.
            </li>
            <li>
              📡 <b>Secure Communication:</b> Encrypted channels for defence,
              aerospace, and government systems.
            </li>
            <li>
              ☁️ <b>Cloud Security:</b> Protecting data and applications hosted
              in hybrid and cloud environments.
            </li>
            <li>
              🧠 <b>AI-driven Threat Intelligence:</b> Early detection and
              response to evolving cyber threats.
            </li>
          </ul>
        </div>
      </div>

      {/* Future Outlook */}
      <div style={{ padding: "24px 16px" }}>
        <div
          style={{
            maxWidth: "1000px",
            margin: "0 auto",
            textAlign: "center",
          }}
        >
          <h2
            style={{
              fontSize: "1.875rem",
              fontWeight: "bold",
              color: "#105184ff",
              marginBottom: "24px",
            }}
          >
            Our Commitment
          </h2>
          <p
            style={{
              fontSize: "1.125rem",
              color: "#333e4fff",
              lineHeight: 1.75,
            }}
          >
            At <b>Technocrat Aerospace & Defence</b>, cybersecurity is not just
            about technology—it is about trust, resilience, and innovation. We
            continuously invest in research, advanced tools, and skilled
            professionals to deliver world-class protection for our partners in
            Aerospace, Aviation, Defence, Railways, and Scientific Research
            sectors.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CyberSecurity;
